<template>
  <table class="icm-tournament-structure icmttstrctr">
    <tr v-if="item.site">
      <td class="icmttstrctr_item_name">{{ $t('table_head.site') }}</td>
      <td class="icmttstrctr_item_val">
        <GwSiteItem
          :siteId="item.site || ''"
          :translate="false"
        />
      </td>
    </tr>

    <tr
      v-for="ii in options"
      :key="ii.name"
    >
      <td class="icmttstrctr_item_name">
        {{ ii.name }}
      </td>
      <td
        class="clr-white icmttstrctr_item_val"
        style="word-break: break-all"
      >
        {{ ii.val }}
      </td>
    </tr>
  </table>
</template>

<script>
import GwSiteItem from '@/components/DataTables/Filters/new/items/GwSiteItem'
import { getSolfigrFields } from '@/store/solfigr/solfigr_helpers'
import format_mix from '@/mixins/format_mix'

export default {
  name: 'SolfigrIcmTournamentStructureItem',
  components: {
    GwSiteItem,
  },
  mixins: [format_mix],
  props: {
    item: Object,
  },
  computed: {
    options() {
      const conf = getSolfigrFields()
      return [
        this.item.name && { val: this.item.name, name: this.$t('table_head.name') },
        {
          val: this.$t(`solfigr.icm.full_name_${this.item.type}`),
          name: this.$t('table_head.tournament_type'),
        },
        // this.item.currency && { val: this.item.currency, name: this.$t('table_head.currency') },
        this.item.prize_pool && {
          val: this.numFixedUnit(this.item.prize_pool, 'icm_payout_prize'),
          name: this.$t('table_head.prize_pool'),
        },
        this.item.total_entrants && {
          val: this.item.total_entrants,
          name: this.$t('table_head.total_entrants'),
        },
        this.item.players_per_table && {
          val: this.item.players_per_table,
          name: this.$t('table_head.players_per_table'),
        },
        conf.bounty_instant_percentage.is_active(this.item.type) && {
          val: `${conf.bounty_instant_percentage.inputFormatter(this.item.bounty_instant_percentage)}%`,
          name: this.$t('table_head.bounty_instant_percentage'),
        },
      ].filter(Boolean)
    },
  },
}
</script>

<style lang="scss" scoped>
.icmttstrctr {
  &_item {
    display: flex;
    flex-direction: var(--icmttstrctr-item-flex-direction);
    gap: var(--icmttstrctr-item-gap);
    &_name {
      color: var(--clr-grey-2);
      padding: 0 1rem 0 0;
      vertical-align: top;
    }
    &_val {
      font-weight: 500;
      vertical-align: top;
    }
  }
}
</style>
